import request from '@/router/axios';

export function getMenu(id) {
  return request({
    url: '/system/menu',
    params: { parentId: id },
    method: 'get',
  });
}

export function fetchMenuTree(lazy, parentId) {
  return request({
    url: '/system/menu/tree',
    method: 'get',
    params: { lazy: lazy, parentId: parentId },
  });
}

export function addObj(obj) {
  return request({
    url: '/system/menu',
    method: 'post',
    data: obj,
  });
}

export function getObj(id) {
  return request({
    url: '/system/menu/' + id,
    method: 'get',
  });
}

export function delObj(id) {
  return request({
    url: '/system/menu/' + id,
    method: 'delete',
  });
}

export function putObj(obj) {
  return request({
    url: '/system/menu',
    method: 'put',
    data: obj,
  });
}

// 获取平台字典
export function platform() {
  return request({
    url: '/system/dict/type/platform',
    method: 'get',
  });
}
